import { observer } from 'mobx-react';
import { UserStatus } from 'st-common/Identity';

@observer
export default class ParticipantsAppUserStatus extends UserStatus {
    protected proxyLabelClass() {
        return "text-dark";
    }

    protected get isParticipantsApp() {
        return true;
    }
}